import fs from 'fs-extra';
import path from 'upath';
import { filter } from 'lodash';

import logger from '@bmd-studio/genstack-logger';
import environment from '@bmd-studio/genstack-environment';

/**
 * Initialize a project with several services
 */  
export const initializeProject = async (projectName: string, force: boolean): Promise<void> => {
  const projectRoot = environment.getProjectRoot(projectName);
  const projectRootNotEmpty = fs.existsSync(projectRoot) ? !!filter(fs.readdirSync(projectRoot), fileName => !(/(^|\/)\.[^/.]/g).test(fileName)).length : false;
  const boilerplateRoot = path.join(__dirname, '../boilerplate');

  // guard: make sure the project root is empty
  if (projectRootNotEmpty && !force) {
    throw Error(`The project directory seems to already contain files. Empty the directory before initializing as there is a risk of overwriting. Use the '--force' flag to force initialization.`);
  }

  // recursively copy the `boilerplate` directory into the project root
  try {
    fs.copySync(boilerplateRoot, projectRoot);
  } catch (error) {
    logger.error.cli(`An error occurred when initializing the project:`);
    logger.error.cli(error);
    throw error;
  }

  // Rename gitignore after the fact to prevent npm from renaming it to .npmignore
  // See: https://github.com/npm/npm/issues/1862
  try {
    fs.moveSync(
      path.join(projectRoot, 'gitignore'),
      path.join(projectRoot, '.gitignore')
    );
  } catch (error) {
    // Append if there's already a `.gitignore` file there
    if (error.code === 'EEXIST') {
      const data = fs.readFileSync(path.join(projectRoot, 'gitignore'));
      fs.appendFileSync(path.join(projectRoot, '.gitignore'), data);
      fs.unlinkSync(path.join(projectRoot, 'gitignore'));
    } else {
      throw error;
    }
  }

  logger.success.cli(`The project is successfully initialized.`);    
};